import { StateCreator } from "zustand";
import { AxiosHttpClient } from "../../../infra/http/axios-http-client";
import { AUTH_HEADER, SECURE_AUTH_TOKEN_KEY, SECURE_BASE_URL_KEY} from "../../../base";
import Endpoints from "../../../domain/endpoints";
import Swal from "sweetalert2";
import { RemoteReactivateUser } from "../../../data/usecases/customer-database/remote-reactivate-user";
import { ReactivateUser } from "../../../domain/useages/customer-database/reactivate-user";
import { CustomerDatabaseStore } from "../../main/CustomerDatabaseStore";
import { getDataKeyFromLocalStorage } from "../../../common/utils/AuthToken";

export interface ReactivateUserInterface {
  reactivateUser: Function;
  handleReactivateLoading: Function;
}

const initialStates = {};

const axiosHttpClient = AxiosHttpClient.getInstance();


export const useReactivateUserSlice: StateCreator<ReactivateUserInterface> = (
  set,
  get
) => ({
  ...initialStates,
  handleReactivateLoading: (value: boolean) => {
    if (value) {
      Swal.fire({
        didOpen: () => {
          if (value) {
            Swal.showLoading();
          }
        },
        customClass: {
          container: "swal2-style",
        },

        title: "Please wait... Customer reactivate request is sending ",
      });
    }
  },

  reactivateUser: async (
    payload: ReactivateUser.Params,
    fetchCustomerData: Function,
    handleCloseModal: Function,
    fetchCustomerSummaryCount: Function
  ) => {
   const token = getDataKeyFromLocalStorage(SECURE_AUTH_TOKEN_KEY) ??"";
   const BASE_URL = getDataKeyFromLocalStorage(SECURE_BASE_URL_KEY);
    axiosHttpClient.setAuthHeaders({
      [AUTH_HEADER]: token.toString(),
    });
    const remoteReactivateUser: ReactivateUser = new RemoteReactivateUser(
      `${BASE_URL}${Endpoints.REACTIVATE_USER}`,
      axiosHttpClient
    );
    get().handleReactivateLoading(true);
    let response = await remoteReactivateUser.reactivate(payload);

    if (response.success) {
      get().handleReactivateLoading(false);
      Swal.fire({
        icon: "success",
        title: response.message,
        timer: 2000,
        customClass: {
          container: "swal2-style",
        },
        confirmButtonColor: "#3085d6",
      });
      handleCloseModal();
      fetchCustomerSummaryCount(CustomerDatabaseStore.getState().filterStore);
      fetchCustomerData();
    } else {
      get().handleReactivateLoading(false);
      Swal.fire({
        icon: "error",
        title: "Reactivate customer request failed",
        text: response.errors.message
          ? response.errors.message
          : response.message,
        customClass: {
          container: "swal2-style",
        },
        confirmButtonColor: "#3085d6",
      });
    }
  },
});
